import React from 'react';
import { Typography, Badge, PillButton, Card, Divider } from "../ecosystem";

const UsersListDropdown = ({
    disabled = false,
    badgeLabel = null,
    onChange = () => { },
    selectedOption,
    options,
}) => {
    const dropdownClasses = [
        `users-list-dropdown`,
        `${disabled ? 'users-list-dropdown--disabled' : ''}`
    ].join(' ');

    const [showOptions, setShowOptions] = React.useState(false);

    const toggleOptions = (e) => {
        setShowOptions(!showOptions);
    }

    const handleBlur = (event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setShowOptions(false);
        }
    }

    const handleSelect = (e, opt) => {
        onChange(opt);
        setShowOptions(false);
    }

    return (<div className={dropdownClasses} tabIndex="0" onBlur={handleBlur}>
        <PillButton
            showArrow={true}
            disabled={disabled}
            label={selectedOption}
            onClick={toggleOptions}
            open={showOptions}
        />
        {options && showOptions &&
            <Card
                className="users-list-dropdown__options"
            >
                <ul
                    role="listbox"
                >
                    {options && options.map((opt, index) => {
                        return (
                            <li
                                key={index}
                                role="option"
                                tabIndex="0"
                                className={`users-list-dropdown__option-item ${opt.className}`}
                                onClick={(e) => handleSelect(e, opt)}
                            >
                                <div className="users-list-dropdown__option-item-content">
                                    <Typography bold={opt.className === "proxy-subheader" || opt.className === "grant-proxy-access"} type="body-02" color="$color-secondary-a2">{opt.label}</Typography>
                                    {badgeLabel &&
                                        <Badge text={badgeLabel} show={opt.showBadge} colorStyle="subtle" />
                                    }
                                </div>
                                {index !== (options.length - 1) && <Divider mTop="none" mBottom="none" mLeft="none" mRight="none" />}
                            </li>
                        )
                    })}
                </ul>
            </Card>
        }
    </div>);
}

export default UsersListDropdown;
